import { Filters as ClaimFilters } from '@/api/claims'
import { Flex } from '@/components'
import { config } from '@/config'
import { Alert } from '@/icons'
import { useLanguage } from '@/utils'
import { Button } from '@surein/ui'
import { useTranslation } from 'react-i18next'
import Filters from './Filters'
import SearchInput from './SearchInput'

type ActionBarProps = {
  setSearch: (search: string) => void
  applyFilters: (filters: ClaimFilters) => void
}

export const ActionBar = ({ setSearch, applyFilters }: ActionBarProps) => {
  const { t } = useTranslation()
  const language = useLanguage()

  const onReportDamageClick = () => {
    window.open(
      config.reportDamageUrl[language],
      '_blank',
      'noopener,noreferrer',
    )
  }

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Filters applyFilters={applyFilters} />
      <Flex gap="8px" alignItems="center">
        <Button variant="outline" icon={Alert} onClick={onReportDamageClick}>
          {t('claimsPage.reportDamage')}
        </Button>
        <SearchInput setSearch={setSearch} />
      </Flex>
    </Flex>
  )
}
